import UpdatePlantingCycle from './UpdatePlantingCycle';

export default UpdatePlantingCycle;
